import { createContext, useContext, useEffect } from 'react';
import Raven from 'raven-js';
const PickersContext = /*#__PURE__*/createContext({});
export default PickersContext;
export const usePickerComponent = name => {
  const context = useContext(PickersContext);
  useEffect(() => {
    if (!context[name]) {
      const err = new Error(`Expected PickersContext.${name} to be provided`);
      console.error(err);
      Raven.captureException(err);
    }
  }, [name, context]);
  return context[name];
};